var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.108 7.247a1.211 1.211 0 0 0-.22 0A2.947 2.947 0 0 1 3.04 4.293c0-1.633 1.32-2.96 2.96-2.96a2.957 2.957 0 0 1 .107 5.913ZM10.94 2.667A2.332 2.332 0 0 1 13.274 5c0 1.26-1 2.287-2.247 2.333a.752.752 0 0 0-.173 0M2.774 9.707c-1.613 1.08-1.613 2.84 0 3.913 1.834 1.227 4.84 1.227 6.674 0 1.613-1.08 1.613-2.84 0-3.913-1.827-1.22-4.834-1.22-6.674 0ZM12.227 13.334c.48-.1.933-.294 1.306-.58 1.04-.78 1.04-2.067 0-2.847a3.315 3.315 0 0 0-1.286-.573"
  })));
};
export default SvgUsers;